/**
 * Shared Framer Motion variants.
 */
import type { Variants, Transition } from "framer-motion";

export const springSoft: Transition = {
  type: "spring",
  stiffness: 180,
  damping: 22,
  mass: 0.9,
};

export const springSnappy: Transition = {
  type: "spring",
  stiffness: 320,
  damping: 24,
  mass: 0.7,
};

export const easeForge: Transition = {
  duration: 0.45,
  ease: [0.22, 1, 0.36, 1],
};

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 16 },
  show:   { opacity: 1, y: 0, transition: easeForge },
};

export const fadeIn: Variants = {
  hidden: { opacity: 0 },
  show:   { opacity: 1, transition: easeForge },
};

export const scaleIn: Variants = {
  hidden: { opacity: 0, scale: 0.94 },
  show:   { opacity: 1, scale: 1, transition: springSnappy },
};

export const revealStagger: Variants = {
  hidden: {},
  show: {
    transition: { staggerChildren: 0.08, delayChildren: 0.05 },
  },
};

export const listItem: Variants = {
  hidden: { opacity: 0, y: 8 },
  show: { opacity: 1, y: 0, transition: springSoft },
  exit: { opacity: 0, y: -4, transition: { duration: 0.16 } },
};

export const messageArrival: Variants = {
  hidden: { opacity: 0, y: 10, scale: 0.985 },
  show: { opacity: 1, y: 0, scale: 1, transition: springSoft },
};

export const statePop: Variants = {
  hidden: { opacity: 0, scale: 0.72 },
  show: { opacity: 1, scale: 1, transition: springSnappy },
  exit: { opacity: 0, scale: 0.84, transition: { duration: 0.14 } },
};

export const successPop: Variants = {
  hidden: { opacity: 0, scale: 0.84, rotate: -8 },
  show: { opacity: 1, scale: 1, rotate: 0, transition: springSnappy },
};

export const cardHover = {
  rest:  { y: 0, scale: 1 },
  hover: { y: -4, scale: 1.01, transition: springSoft },
  tap:   { scale: 0.985, transition: springSnappy },
};